// Documents Needed page component
export function DocumentsNeededPage() {
  return `
<div class="hero">
  <div class="hero-content">
    <h1 class="hero-title">Documentos Necesarios</h1>
    <p class="hero-subtitle">Prepare estos documentos para agilizar el proceso de certificación</p>
  </div>
</div>

<section class="section bg-gray-50">
  <div class="container">
    <div class="bg-blue-50 border-l-4 border-blue-500 p-6 mb-12 rounded-lg">
      <h3 class="text-lg font-bold text-blue-900 mb-2 flex items-center">
        <span class="mr-2">📋</span>Documentos Esenciales
      </h3>
      <p class="text-blue-700">Estos documentos son necesarios para elaborar el certificado CEE de su vivienda</p>
    </div>

    <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">

      <div class="card border-l-4 border-red-500">
        <div class="inline-block bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm font-medium mb-4">Obligatorio</div>
        <h3 class="text-xl font-bold text-gray-900 mb-3 flex items-center">
          <span class="mr-2">📄</span>Escritura o Certificado Catastral
        </h3>
        <p class="text-gray-600 mb-4">Para verificar la superficie exacta de la vivienda</p>
        <ul class="space-y-2 text-sm text-gray-600">
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Superficie útil y construida</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Descripción de la vivienda</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Año de construcción</li>
        </ul>
      </div>

      <div class="card border-l-4 border-red-500">
        <div class="inline-block bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm font-medium mb-4">Obligatorio</div>
        <h3 class="text-xl font-bold text-gray-900 mb-3 flex items-center">
          <span class="mr-2">🆔</span>ID del Propietario
        </h3>
        <p class="text-gray-600 mb-4">Identificación del propietario de la vivienda</p>
        <ul class="space-y-2 text-sm text-gray-600">
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Documento válido</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Copia clara y legible</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Anverso y reverso</li>
        </ul>
      </div>

      <div class="card border-l-4 border-green-500">
        <div class="inline-block bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium mb-4">Recomendado</div>
        <h3 class="text-xl font-bold text-gray-900 mb-3 flex items-center">
          <span class="mr-2">🏗️</span>Proyecto de Construcción
        </h3>
        <p class="text-gray-600 mb-4">Si dispone del proyecto original o de reformas</p>
        <ul class="space-y-2 text-sm text-gray-600">
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Planos de la vivienda</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Memoria descriptiva</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Especificaciones técnicas</li>
        </ul>
      </div>

      <div class="card border-l-4 border-green-500">
        <div class="inline-block bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium mb-4">Recomendado</div>
        <h3 class="text-xl font-bold text-gray-900 mb-3 flex items-center">
          <span class="mr-2">⚡</span>Facturas Energéticas
        </h3>
        <p class="text-gray-600 mb-4">Para validar el consumo energético real</p>
        <ul class="space-y-2 text-sm text-gray-600">
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Electricidad (último año)</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Gas (último año)</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Gasóleo/Propano si aplica</li>
        </ul>
      </div>

      <div class="card border-l-4 border-yellow-500">
        <div class="inline-block bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-sm font-medium mb-4">Opcional</div>
        <h3 class="text-xl font-bold text-gray-900 mb-3 flex items-center">
          <span class="mr-2">🔧</span>Certificados de Instalaciones
        </h3>
        <p class="text-gray-600 mb-4">Si tiene certificados de caldera, aire acondicionado, etc.</p>
        <ul class="space-y-2 text-sm text-gray-600">
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Caldera o termo</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Aire acondicionado</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Instalación eléctrica</li>
        </ul>
      </div>

      <div class="card border-l-4 border-yellow-500">
        <div class="inline-block bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-sm font-medium mb-4">Opcional</div>
        <h3 class="text-xl font-bold text-gray-900 mb-3 flex items-center">
          <span class="mr-2">🌞</span>Energías Renovables
        </h3>
        <p class="text-gray-600 mb-4">Documentación de sistemas de energía renovable instalados</p>
        <ul class="space-y-2 text-sm text-gray-600">
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Paneles solares</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Bomba de calor aerotérmica</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Geotermia</li>
        </ul>
      </div>

    </div>
  </div>
</section>


<section class="section bg-gray-50">
  <div class="container max-w-4xl mx-auto">
    <h2 class="text-3xl font-bold text-center text-gray-900 mb-12">Checklist</h2>
    <div class="grid md:grid-cols-2 gap-8">

      <div class="card">
        <h3 class="text-xl font-bold text-gray-900 mb-6 flex items-center">
          <span class="mr-2">✅</span>Antes de la Visita
        </h3>
        <div class="space-y-4">
          <label class="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" id="escrituras" class="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500">
            <span class="text-gray-700">Escrituras o certificado catastral</span>
          </label>
          <label class="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" id="dni" class="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500">
            <span class="text-gray-700">ID del propietario (copia)</span>
          </label>
          <label class="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" id="facturas" class="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500">
            <span class="text-gray-700">Facturas de luz y gas del último año</span>
          </label>
          <label class="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" id="acceso" class="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500">
            <span class="text-gray-700">Asegurar acceso a todas las estancias</span>
          </label>
          <label class="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" id="llaves" class="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500">
            <span class="text-gray-700">Llaves de contadores y cuadros eléctricos</span>
          </label>
        </div>
      </div>

      <div class="card">
        <h3 class="text-xl font-bold text-gray-900 mb-6 flex items-center">
          <span class="mr-2">📂</span>Si Está Disponible
        </h3>
        <div class="space-y-4">
          <label class="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" id="planos" class="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500">
            <span class="text-gray-700">Planos de la vivienda</span>
          </label>
          <label class="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" id="proyecto" class="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500">
            <span class="text-gray-700">Proyecto de construcción original</span>
          </label>
          <label class="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" id="reforma" class="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500">
            <span class="text-gray-700">Documentación de reformas</span>
          </label>
          <label class="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" id="certificados" class="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500">
            <span class="text-gray-700">Certificados de equipos</span>
          </label>
          <label class="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" id="renovables" class="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500">
            <span class="text-gray-700">Documentación de energías renovables</span>
          </label>
        </div>
      </div>

    </div>
  </div>
</section>


<section class="section bg-white">
  <div class="container">
    <h2 class="text-3xl font-bold text-center text-gray-900 mb-12">¿Le Faltan Algunos Documentos?</h2>
    <div class="grid md:grid-cols-2 gap-8">

      <div class="card">
        <h3 class="text-xl font-bold text-gray-900 mb-4 flex items-center">
          <span class="mr-2">🔍</span>Podemos Ayudar
        </h3>
        <p class="text-gray-600 mb-4">Si le falta algún documento, nuestro técnico puede:</p>
        <ul class="space-y-2 text-gray-600">
          <li class="flex items-center"><span class="text-green-500 mr-2">✓</span>Realizar mediciones directas in situ</li>
          <li class="flex items-center"><span class="text-green-500 mr-2">✓</span>Consultar bases de datos oficiales</li>
          <li class="flex items-center"><span class="text-green-500 mr-2">✓</span>Estimar datos según normativa</li>
          <li class="flex items-center"><span class="text-green-500 mr-2">✓</span>Asesorarle para obtener documentos</li>
        </ul>
      </div>

      <div class="card">
        <h3 class="text-xl font-bold text-gray-900 mb-4 flex items-center">
          <span class="mr-2">📋</span>Alternativas
        </h3>
        <p class="text-gray-600 mb-4">Para casos sin documentación:</p>
        <ul class="space-y-2 text-gray-600">
          <li><span class="font-semibold">Certificado catastral:</span> Catastro (≈ 9 €)</li>
          <li><span class="font-semibold">Facturas:</span> Solicitarlas a la compañía energética</li>
          <li><span class="font-semibold">Planos:</span> Colegio de arquitectos local</li>
          <li><span class="font-semibold">Certificados:</span> Empresa instaladora</li>
        </ul>
      </div>

    </div>
  </div>
</section>


<section class="section bg-gray-50">
  <div class="container">
    <h2 class="text-3xl font-bold text-center text-gray-900 mb-12">Consejos de Preparación</h2>

    <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">

      <div class="card">
        <h3 class="text-lg font-bold text-gray-900 mb-4 flex items-center">
          <span class="mr-2">🏠</span>Acceso a la Vivienda
        </h3>
        <ul class="space-y-2 text-sm text-gray-600">
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Todas las estancias accesibles</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Terraza/balcón despejado</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Trasteros y buhardillas si forman parte</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Garaje si se incluye en la superficie</li>
        </ul>
      </div>

      <div class="card">
        <h3 class="text-lg font-bold text-gray-900 mb-4 flex items-center">
          <span class="mr-2">⚡</span>Instalaciones
        </h3>
        <ul class="space-y-2 text-sm text-gray-600">
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Localizar cuadro eléctrico</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Acceso a contadores</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Armarios de instalaciones</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Acceso a caldera/termo</li>
        </ul>
      </div>

      <div class="card">
        <h3 class="text-lg font-bold text-gray-900 mb-4 flex items-center">
          <span class="mr-2">📝</span>Información Útil
        </h3>
        <ul class="space-y-2 text-sm text-gray-600">
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Año de construcción del edificio</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Reformas realizadas y fechas</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Cambios en las instalaciones</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Problemas detectados (humedades, etc.)</li>
        </ul>
      </div>

      <div class="card">
        <h3 class="text-lg font-bold text-gray-900 mb-4 flex items-center">
          <span class="mr-2">⏰</span>Durante la Visita
        </h3>
        <ul class="space-y-2 text-sm text-gray-600">
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Presencia del propietario o representante</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Duración estimada: 1-3 horas</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>El técnico debe tomar fotografías</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Posibles preguntas sobre uso de la vivienda</li>
        </ul>
      </div>

    </div>

    <h3 class="text-2xl font-bold text-center text-gray-900 mb-8">Preguntas Frecuentes</h3>

    <div class="space-y-6 max-w-3xl mx-auto">

      <div class="card">
        <h4 class="text-lg font-semibold text-gray-900 mb-2">¿Qué ocurre si no tengo las escrituras?</h4>
        <p class="text-gray-600">Puede solicitar un certificado catastral en el Catastro por unos 9 €. También podemos continuar con mediciones directas, aunque es menos preciso.</p>
      </div>

      <div class="card">
        <h4 class="text-lg font-semibold text-gray-900 mb-2">¿Son necesarias las facturas de energía?</h4>
        <p class="text-gray-600">No son obligatorias, pero nos ayudan a validar los cálculos teóricos con el consumo real, mejorando la precisión del certificado.</p>
      </div>

      <div class="card">
        <h4 class="text-lg font-semibold text-gray-900 mb-2">¿Qué pasa si soy inquilino?</h4>
        <p class="text-gray-600">Necesita autorización del propietario y una copia de su identificación. El propietario debe estar informado y dar permiso para la certificación.</p>
      </div>

      <div class="card">
        <h4 class="text-lg font-semibold text-gray-900 mb-2">¿Puedo enviar los documentos por email?</h4>
        <p class="text-gray-600">Sí, puede enviar copias digitales antes de la visita. El técnico también puede revisarlos durante la inspección si lo prefiere.</p>
      </div>

    </div>
  </div>
</section>


<section class="section bg-blue-600 text-white">
  <div class="container text-center">
    <h2 class="text-3xl font-bold mb-4">¿Lo Tiene Todo Listo?</h2>
    <p class="text-xl mb-8 opacity-90">Con la documentación preparada, el proceso es más rápido y preciso</p>
    <button class="btn bg-white text-blue-600 hover:bg-gray-100" data-route="/book-epc/">Reservar Certificado CEE</button>
  </div>
</section>

  `;
}
